import React from 'react';
import {AthleteLinkModel} from "../../../containers/athlete-container/models/athlete-link-model";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {FooterButtons} from "../../../core/components/footer-buttons/footer-buttons";

export const CompetitorPlayersStatsModuleFooterButtons = (({controller, onClose, competitionId}) => {
  const {state, terms: i18n, props} = controller;
  const {gameId, source} = props;
  const {
    selectedPlayer,
    gameStatus,
    selectedAthleteId,
    currentLinkModel,
    shouldRenderPlayerDetailsButton,
    shouldRenderGameDetailsButton,
    gameLinkModel,
    game
  } = state;

  const {domainModel: {sport, nameForUrl, isNational, name}} = selectedPlayer;

  const onButtonClick = (clickType) => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onButtonClick, {
    gameId,
    source,
    clickType,
    status: gameStatus,
    athleteId: selectedAthleteId,
    sportTypeId: sport.id
  })

  const footerButtonProps = {
    controller,
    onClose: () => {
      onClose();
      onButtonClick(COMPETITOR_PLAYER_STATS.CLICK_TYPE.close)
    },
  }


  const playerDetailsButtonProps = {
    ...footerButtonProps,
    buttonLabel: name || i18n.WEB_POP_STATS_PLAYER_DETAILS_BUTTON,
    buttonLinkModel: new AthleteLinkModel(selectedPlayer.athleteId, sport.nameForURL, nameForUrl, isNational, competitionId, null, null, selectedPlayer?.isFollow),
    onClick: () => {
      onButtonClick(COMPETITOR_PLAYER_STATS.CLICK_TYPE.playerDetails)
      controller.action(ACTION_TYPES.entityClick, {
        entityId: selectedPlayer.athleteId,
        entityName: selectedPlayer.nameForURL,
        entityType: APP.ANALYTICS.USER_SELECTIONS.TYPES.AthleteViewModel,
        source: APP.ANALYTICS.SOURCES.playerCard,
        sportTypeId: selectedPlayer.sport.id,
        currentLinkModel
      })

      return true
    }
  }

  const gameDetailsButtonProps = {
    ...footerButtonProps,
    buttonLabel: i18n.WEB_ATHLETE_GAMES_DETAILS,
    buttonLinkModel: gameLinkModel,
    onClick: () => {
      onButtonClick(COMPETITOR_PLAYER_STATS.CLICK_TYPE.gameDetails)
      controller.action(ACTION_TYPES.matchDetailsClick, {
        gameId: gameId,
        competitionId: game.competition.id,
        status: gameStatus,
        source: APP.ANALYTICS.SOURCES.playerCard,
        currentLinkModelName: currentLinkModel.name,
        sportTypeId: game.sport.id,
      })

      return true
    }
  }

  const footerProps = shouldRenderPlayerDetailsButton ? playerDetailsButtonProps : (shouldRenderGameDetailsButton ? gameDetailsButtonProps : {});

  return (<FooterButtons {...footerProps} shouldRenderEntityButton={shouldRenderPlayerDetailsButton || shouldRenderGameDetailsButton}/>
  )
});
